import { ThemeOptions } from '@mui/material/styles/createTheme';

import { tokens } from '../../../theme/generated/tokens';

const disabledUncheckedBodyStyles = {
  backgroundColor: tokens.theme.disabled.surface,
  border: `1px solid ${tokens.theme.disabled.border}`,
};

const disabledCheckedBodyStyles = {
  backgroundColor: tokens.theme.disabled.bg,
  border: `1px solid ${tokens.theme.disabled.border}`,
};

export const checkboxTheme: ThemeOptions['components'] = {
  MuiCheckbox: {
    defaultProps: {
      disableRipple: true,
    },
    styleOverrides: {
      root: ({ theme: _theme }) => ({
        '&:hover, &:active, .MuiListItemButton-root:hover &': {
          '--checkboxBorder': tokens.theme.border.action.neutralHover,
        },
        padding: '0',
        '& .MuiCheckbox-body': {
          background: tokens.theme.bg.structural.surface,
          width: '1em',
          height: '1em',
          boxSizing: 'border-box',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: tokens.theme.radius.sm,
          border: `1px solid var(--checkboxBorder, ${tokens.theme.border.structural.neutral})`,
          transition: 'border-radius ease-in-out 0.1s',
          '&.MuiCheckbox-fontSize-medium': {
            fontSize: 20,
          },
          '&.MuiCheckbox-fontSize-small': {
            fontSize: 16,
          },
        },
        '& .MuiCheckbox-checkmark': {
          fontSize: '0.5em',
          color: `var(--checkboxCheckmark, ${tokens.theme.fg.selection.onPrimary})`,
        },
        '&:active': {
          '& .MuiCheckbox-body': {
            borderRadius: '40%',
          },
        },
        '&.Mui-focusVisible .MuiCheckbox-body': {
          outline: `2px solid ${tokens.theme.border.focus}`,
        },

        '&.Mui-checked': {
          '& .MuiCheckbox-body': {
            '&:not(.Mui-focusVisible)': {
              border: 'none',
            },
            backgroundColor: 'var(--checkboxBackground)',
          },
          '&:not(.MuiCheckbox-indeterminate) .MuiCheckbox-checkmark': {
            fontSize: '0.7em',
            '& polyline': {
              strokeWidth: 32,
            },
          },
        },
        '&.Mui-disabled': {
          '--checkboxBackground': tokens.theme.disabled.bg,
          '--checkboxBorder': tokens.theme.disabled.border,
          '--checkboxCheckmark': tokens.theme.disabled.fg,
          '&:not(.Mui-checked) .MuiCheckbox-body': disabledUncheckedBodyStyles,
          '&.Mui-checked .MuiCheckbox-body': disabledCheckedBodyStyles,
          '& .MuiCheckbox-checkmark': {
            color: tokens.theme.disabled.fg,
          },
        },
      }),
      colorPrimary: () => ({
        '--checkboxBackground': tokens.theme.bg.selection.primary,
        '--checkboxCheckmark': tokens.theme.fg.selection.onPrimary,
        '&:hover': {
          '--checkboxBackground': tokens.theme.bg.selection.primaryHover,
        },
        '&:active': {
          '--checkboxBackground': tokens.theme.bg.selection.primaryActive,
        },
      }),
      colorError: () => ({
        '--checkboxBackground': tokens.theme.bg.selection.primary,
        '--checkboxBorder': tokens.theme.border.status.error,
        '--checkboxCheckmark': tokens.theme.fg.selection.onPrimary,
        '&:hover, .MuiListItemButton-root:hover &': {
          '--checkboxBorder': tokens.theme.border.selection.errorHover,
          '--checkboxBackground': tokens.theme.bg.selection.primaryHover,
        },
        '&:active': {
          '--checkboxBorder': tokens.theme.bg.selection.errorActive,
          '--checkboxBackground': tokens.theme.bg.selection.primaryActive,
        },
      }),
    },
  },
};
